// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'List of Generated Reports'"></sub-header>
  <div>
    <a class="pull-right btn btn-primary"
       ng-click="\$ctrl.\$onInit()">
        Refresh
    </a>
    <dynamic-list
      columns="\$ctrl.columns"
      data="\$ctrl.reportList">
    </dynamic-list>

    <div ng-if="\$ctrl.reportList.length == 0" class="empty-message">
      <span>No generated reports.</span>
    </div>

    <div class="buttons">
      <button class="btn btn-warning" ng-click="\$ctrl.goBack()">Back</button>
    </div>
  </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/report/dynamic-report-tool-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;